<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>數據統計</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>賃居訪視表</span></li>
          <li><span>數據統計</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="left">
              <div align="left">
                請選擇學年度:
                <select v-model="search.schYearTerm">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearTermList" :key="item" :value="item.replace('/', '')">{{item}}</option>
                </select>
              </div>
              <div align="center" style="padding:7px;">
                <a href="#" @click.prevent="download" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">匯出數據統計表</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      schYearTermList: [],
      search: {
        schYearTerm: null,
      },
    };
  },
  mounted() {
    let d = this.nowDate();
    let nowSchYear = d.getFullYear() - 1911;
    for (let i = nowSchYear; i >= 108; i--) {
      if (i == nowSchYear) {
        let month = d.getMonth() + 1;
        if (month < 8) continue;
        else this.schYearTermList.push(i.toString() + "/1");
      } else {
        this.schYearTermList.push(i.toString() + "/2");
        this.schYearTermList.push(i.toString() + "/1");
      }
    }
  },
  methods: {
    download() {
      if (this.search.schYearTerm == null) {
        alert("請選擇學年度");
        return;
      }
      this.$http
        .post("/api/tenancyVisit/statistic?schYearTerm=" + this.search.schYearTerm, {}, { responseType: "arraybuffer" })
        .then(res => {
          this.download2File(res);
        });
    }
  }
};
</script>

<style>
</style>